module.exports = __webpack_public_path__ + "img/6.8026d742.png";